import logo_black_orange from "src/assets/icons/logo_black_orange.png";
import logo_white_orange from "src/assets/icons/logo_white_orange.png";
import avatar from "src/assets/icons/avatar.png";
import nta from "src/assets/icons/nta.png";
import virtualsupport from "src/assets/icons/virtualsupport.png";
import helpline from "src/assets/icons/helpline.png";
import clock from "src/assets/icons/clock.png";
import question from "src/assets/icons/question.png";
import marks from "src/assets/icons/marks.png";
import pieChart from "src/assets/icons/piechart.png";
import scoreSpeedometer from "src/assets/icons/score_speedometer.png";
import scoreMedal from "src/assets/icons/scoreMedal.png";
import target from "src/assets/icons/target.png";
import time_passing from "src/assets/icons/time_passing.png";
import trophy from "src/assets/icons/trophy.png";
import wrongPaper from "src/assets/icons/wrong_paper.png";
import unattendedPaper from "src/assets/icons/unattendedPaper.png";
import checkPaper from "src/assets/icons/check_paper.png";
export const icons = {
  logo_black_orange,
  logo_white_orange,
  avatar,
  nta,
  virtualsupport,
  helpline,
  clock,
  question,
  marks,
  pieChart,
  scoreSpeedometer,
  scoreMedal,
  target,
  time_passing,
  trophy,
  wrongPaper,
  unattendedPaper,
  checkPaper,
};

export const images = {};
